import "./AllPortfolio.scss";
import MyPortfolio from "../../components/MyPortfolio/MyPortfolio";
import FadeIn from "../../components/FadeIn/FadeIn";

const Section = ({ children }) => {
  const [ref, isVisible] = FadeIn(0.2);
  return (
    <section ref={ref} className={`fade-in-section ${isVisible ? "visible" : ""}`}>
      {children}
    </section>
  )
}

const AllPortfolio = ({portfolioData}) => {
        // Генерация массива с падающими 0 и 1
        const generateFallingNumbers = () => {
          return Array.from({ length: 50 }, (_, index) => {
            // Генерация случайной позиции X вне центральной области (30%-70%)
            const randomX = Math.random() < 0.5 
              ? Math.random() * 0.3 
              : Math.random() * 0.3 + 0.7;
      
            return (
              <span
                key={index}
                className="falling-number"
                style={{
                  "--random-x": randomX,
                  "--random-duration": Math.random() * 5,
                  "--random-delay": Math.random() ,
                }}
              >
                {Math.random() > 0.5 ? 1 : 0}
              </span>
            );
          });
        }
        return (
          <Section>
          <section className="all-portfolio">
            <h2>
              All <span>Portfolio</span>
            </h2>
            <p>Here I will place all my portfolios</p>
            <p>On this page, by clicking on the link, you will be taken to the site description.</p>
            <div className="portfolio__items row">

              <MyPortfolio portfolioData={portfolioData} cardsToWatch={"all"}/>

            </div>
            {/* Блок с падающими 0 и 1 */}
            <div className="falling-numbers">{generateFallingNumbers()}</div>
          </section>
          </Section>
        );
      };
      

export default AllPortfolio;
